import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import CaseComponent from "../common/CaseComponent";
import RunNewSearch from "./RunNewSearch";
import { getErrorComponent } from "../messages/ErrorComponent";

function getErrorMessage(actCode, vendorError) {
  if(vendorError === undefined || vendorError === null || vendorError === "")
    return "";
  if(vendorError.indexOf("Provider error") !== -1) {
    return "Provider error occurred, please try again.";
  }
  const tokens = _.split(vendorError, ": ");
  if (tokens.length > 1) {
    const errorCode = tokens[0];
    if(errorCode.indexOf("ERR ") !== -1 && errorCode.length > 5) {
      const errNumber = parseInt(errorCode.replace(errorCode.substring(0, 5), "").trim(), 10);
      console.log("errNumber", errNumber);
      const errMessage = tokens[1];
      switch (errNumber) {
        case 1:
          if(actCode !== undefined && actCode === "200")
            return "Please narrow your search: you only get up to 3 addresses and no phone numbers when over 25 matches were found.";
            return "Please narrow your search: too many results found for your criteria.";
        case 6:
          return "Please narrow your search: add more criteria to perform search.";
        default:
          return errMessage !== null && errMessage !== undefined && errMessage !== "" ? errMessage : "Unknown error, please try again.";
      }
    }
  }
  return "Unable to process the search, please try again.";
}

class SearchResultHeader extends Component {
  componentDidMount() {}

  render() {
    const { searchResultData, userAccount } = this.props;
    const log = this.props.log;
    const actDesc = _.get(log, "actDesc[0]");
    const actId = _.get(log, "actID[0]");
    let criteria = "";
    if (actDesc !== undefined)
      if (actDesc.indexOf("with") !== -1)
        criteria = actDesc.substring(0, actDesc.indexOf("with"));
      else criteria = actDesc;
    const { additionalData, vendorError } = this.props;
    const actCharge = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actCharge[0]`
    );
    const actType = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actType[0]`
    );
    const actCode = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actCode[0]`
    );
    const actPrice = _.get(
      searchResultData,
      `${Object.keys(searchResultData)[0]}.log[0].actPrice[0]`
    );
    const errorMessage = getErrorMessage(actCode, vendorError);
    return (
      <div>
        <Table>
          <Table.Body>
            <Table.Row
              className={
                userAccount && userAccount.acctTheme === 0
                  ? "ui-widget-header-blue"
                  : "result-criteria-header"
              }
            >
              <Table.Cell width={10} className={"icon-align-middle"}>
                {criteria}
              </Table.Cell>
              <Table.Cell width={4}>
                <div className={`no-print float-right`}>
                  <CaseComponent
                    {...this.props}
                    actId={actId}
                    comptType={"result"}
                  />
                </div>
              </Table.Cell>
              <Table.Cell width={2}>
                <div className={`no-print float-right margin-top-3`}>
                  <Button
                    className={"margin-left-10"}
                    onClick={() =>
                      this.props.printContent("result", `Results - ${criteria}`)
                    }
                  >
                    Print
                  </Button>
                </div>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Table className="table-no-margin">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan={2}>
                {/* {showNarrowSearchMessage && (
                  <center>
                    Please narrow your search: you only get upto 3
                    addresses and no phone numbers when over 25 matches
                    were found.
                    <br />
                  </center>
                )} */}
                {errorMessage !== "" && (
                  <center>
                    {errorMessage}
                    <br />
                  </center>
                )}
                {additionalData &&
                  additionalData.errorMessage &&
                  additionalData.errorMessage !== "" &&
                  getErrorComponent(
                    additionalData.errorMessage,
                    actCharge,
                    actType,
                    actPrice
                  )}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Table className="table-no-margin">
          <Table.Body>
            <RunNewSearch
              actID={_.get(log, "xmlID[0]")}
              actDate={_.get(log, "actDate[0]")}
              actType={_.get(log, "actType[0]")}
              reportID={_.get(log, "reportID[0]")}
              showResults={this.props.showResults}
              data={this.props.formData}
              acctTheme={userAccount.acctTheme}
            />
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default SearchResultHeader;



// WEBPACK FOOTER //
// ./src/components/searchresults/SearchResultHeader.js